<ng-container>
  <front-header [content]="'Contact'"/>

  <div
    [contentFlex]="'content'"
    [row]="'computer'"
    class="contact-container"
  >
    <div
      [contentFlex]="'content'"
      [col]="'12|6-computer'"
      class="contact-us-message"
    >
      <h1 [title]="'Contact us' | trans">
        {{ 'Contact us' | trans }}
      </h1>

      <div
        [renderHtml]="'Contact us desc'"
        class="contact-us-desc"
      ></div>
    </div>

    <div
      [contentFlex]="'content'"
      [col]="'12|6-computer'"
    >
      <contact-form/>
    </div>
  </div>

</ng-container>
